export const INSTALL_PWA_SESSION_TOKEN_KEY = 'token';

export type InstallPwaSessionStorage = Pick<Storage, 'getItem' | 'setItem'>;

export type InstallPwaSessionWithToken = {
	token?: string | null;
};

type RestoreInstallPwaSessionOptions<T extends InstallPwaSessionWithToken> = {
	standalonePwa: boolean;
	storage: InstallPwaSessionStorage;
	loadSessionFromCookie: () => Promise<T>;
};

/**
 * Restores the browser session when iOS gives a Home Screen web app a fresh
 * localStorage namespace. The backend's HttpOnly auth cookie remains the
 * source of truth; the returned bearer token is only copied into the app's
 * existing localStorage slot so the rest of the host can stay unchanged.
 */
export const restoreInstallPwaSessionFromCookie = async <T extends InstallPwaSessionWithToken>({
	standalonePwa,
	storage,
	loadSessionFromCookie
}: RestoreInstallPwaSessionOptions<T>): Promise<T | null> => {
	if (!standalonePwa || storage.getItem(INSTALL_PWA_SESSION_TOKEN_KEY)) return null;

	try {
		const session = await loadSessionFromCookie();
		if (!session?.token) return null;
		storage.setItem(INSTALL_PWA_SESSION_TOKEN_KEY, session.token);
		return session;
	} catch {
		// A missing/expired cookie follows the normal unauthenticated route.
		return null;
	}
};
